import React, { useEffect, useState } from 'react';
import {
  formattedWinningsPerPosition,
  getMatchStatus,
  isGadgetLeague,
  isSmartPhone
} from '../../../utilities/helper';
import useGame from '../../../utilities/hooks/game';

import ContestDetailsMWeb from './index_mWeb';
import ContestDetailsWeb from './index_web';

const ContestDetails = () => {
  const {
    gameType,
    item: matchItem,
    userId = '',
    myTeamList = [],

    fantasyMatchClick,
    getContestLeaderboard,
    getPlayerList,
    getContestUserLeaderboard
  } = useGame();

  const totalTeamsCount = myTeamList.length;
  const {
    _id: matchId = '',
    status: matchStatus = '',
    verified: matchVerifiedStatus = false,
    gameState = 0,
    contest = {},
    completed = false,
    tabType = '',
    matchDelayed = false,
    matchTeamLock = false
  } = matchItem;

  const [winningData, setWinningData] = useState([]);
  const [contestDetail, setContestDetails] = useState({});
  const [contestShare, setContestShare] = useState(false);
  const [contestLink] = useState('');
  const [contestTitle] = useState('');

  const {
    _id: contestId = '',
    entryFee = 0,
    bonusPercentage,
    winningsPerPosition,
    title = '',
    description = ''
  } = contest;

  const isGadgetLeague_ = isGadgetLeague(title);

  useEffect(() => {
    setWinningData(formattedWinningsPerPosition(winningsPerPosition));
    setContestDetails(contest);
  }, []);

  const onPressShare = async () => {};

  const onPressShareModalDismiss = () => {
    setContestShare(false);
  };

  const { teamA, teamB, status, verified = false } = matchItem;

  return (
    <React.Fragment>
      {isSmartPhone ? (
        <ContestDetailsMWeb
          teamA={teamA}
          teamB={teamB}
          getMatchStatus={getMatchStatus}
          onPressShare={onPressShare}
          contestDetail={contestDetail}
          status={status}
          verified={verified}
          matchStatus={matchStatus}
          gameState={gameState}
          matchItem={matchItem}
          totalTeamsCount={totalTeamsCount}
          matchDelayed={matchDelayed}
          gameType={gameType}
          getContestUserLeaderboard={getContestUserLeaderboard}
          getContestLeaderboard={getContestLeaderboard}
          fantasyMatchClick={fantasyMatchClick}
          completed={completed}
          contestId={contestId}
          userId={userId}
          winningsPerPosition={winningsPerPosition}
          entryFee={entryFee}
          tabType={tabType}
          matchVerifiedStatus={matchVerifiedStatus}
          bonusPercentage={bonusPercentage}
          matchId={matchId}
          getPlayerList={getPlayerList}
          matchTeamLock={matchTeamLock}
          myTeamList={myTeamList}
          isGadgetLeague_={isGadgetLeague_}
          description={description}
          winningData={winningData}
          contestLink={contestLink}
          contestTitle={contestTitle}
          contestShare={contestShare}
          onPressShareModalDismiss={onPressShareModalDismiss}
        />
      ) : (
        <ContestDetailsWeb
          teamA={teamA}
          teamB={teamB}
          getMatchStatus={getMatchStatus}
          onPressShare={onPressShare}
          contestDetail={contestDetail}
          status={status}
          verified={verified}
          matchStatus={matchStatus}
          gameState={gameState}
          matchItem={matchItem}
          totalTeamsCount={totalTeamsCount}
          matchDelayed={matchDelayed}
          gameType={gameType}
          getContestUserLeaderboard={getContestUserLeaderboard}
          getContestLeaderboard={getContestLeaderboard}
          fantasyMatchClick={fantasyMatchClick}
          completed={completed}
          contestId={contestId}
          userId={userId}
          winningsPerPosition={winningsPerPosition}
          entryFee={entryFee}
          tabType={tabType}
          matchVerifiedStatus={matchVerifiedStatus}
          bonusPercentage={bonusPercentage}
          matchId={matchId}
          getPlayerList={getPlayerList}
          matchTeamLock={matchTeamLock}
          myTeamList={myTeamList}
          isGadgetLeague_={isGadgetLeague_}
          description={description}
          winningData={winningData}
          contestLink={contestLink}
          contestTitle={contestTitle}
          contestShare={contestShare}
          onPressShareModalDismiss={onPressShareModalDismiss}
        />
      )}
    </React.Fragment>
  );
};
export default ContestDetails;
